"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateConverter = void 0;
var isDateString = function (str) { return !Number.isNaN(Date.parse(str)); };
var DateConverter = /** @class */ (function () {
    function DateConverter() {
    }
    DateConverter.prototype.canConvertToCustomFormat = function (obj) {
        return obj instanceof Date;
    };
    DateConverter.prototype.convertToCustomFormat = function (date) {
        return {
            $date: date.toISOString(),
        };
    };
    DateConverter.prototype.canConvertFromCustomFormat = function (obj) {
        return this._isObjectWith$Date(obj) && typeof obj.$date === "string" && isDateString(obj.$date);
    };
    DateConverter.prototype.convertFromCustomFormat = function (obj) {
        return new Date(obj.$date);
    };
    DateConverter.prototype._isObjectWith$Date = function (obj) {
        return !!obj && typeof obj === "object" && "$date" in obj;
    };
    return DateConverter;
}());
exports.DateConverter = DateConverter;
//# sourceMappingURL=DateConverter.js.map